export default __webpack_public_path__ + "static/media/mbbsBanner-02.79ecfcf2.png";